// Utilidades de la guia para el usuario: descargas, copiar y recordar datos en el navegador.
export const descargar = (nombre, texto, tipo = "text/plain;charset=utf-8") => {
    try {
        const url = URL.createObjectURL(new Blob([texto], { type: tipo }));
        const a = document.createElement("a");
        a.href = url; a.download = nombre; document.body.appendChild(a); a.click(); a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (e) { /* el navegador no permite descargar */ }
};

export const copiar = async (texto) => {
    try { await navigator.clipboard.writeText(texto); return true; } catch (e) { return false; }
};

export const leerJson = (clave, defecto) => { try { const v = JSON.parse(localStorage.getItem(clave)); return v == null ? defecto : v; } catch (e) { return defecto; } };
export const guardarJson = (clave, valor) => { try { localStorage.setItem(clave, JSON.stringify(valor)); } catch (e) { /* sin almacenamiento: no se recuerda */ } };

export const csv = (filas) => filas.map(f => f.map(c => `"${String(c == null ? "" : c).replace(/"/g, '""')}"`).join(",")).join("\r\n");

// Convierte un <svg> en PNG (fondo blanco, el doble de resolucion) y lo descarga
export const svgAPng = (svg, nombre) => {
    try {
        const vb = (svg.getAttribute("viewBox") || "0 0 800 340").split(/\s+/).map(Number);
        const [w, h] = [vb[2] || 800, vb[3] || 340];
        const clon = svg.cloneNode(true);
        clon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        clon.setAttribute("width", w); clon.setAttribute("height", h);
        clon.style.maxHeight = "none"; clon.style.color = "#212529";
        const img = new Image();
        img.onload = () => {
            const c = document.createElement("canvas");
            c.width = w * 2; c.height = h * 2;
            const g = c.getContext("2d");
            g.fillStyle = "#ffffff"; g.fillRect(0, 0, c.width, c.height);
            g.drawImage(img, 0, 0, c.width, c.height);
            c.toBlob((b) => { if (b) descargar(nombre, b, "image/png"); }, "image/png");
        };
        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(clon));
    } catch (e) { /* sin soporte de canvas */ }
};
